import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div
      className={`sub-details-header-wrapper ${props.option}
         ${props.isActive ? "active-me" : ""} `}
    >
      <div className={"header"}>{props.title}</div>

      {props.isLeftText && <div className={"wizard-header"}>{props.leftText}</div>}
    </div>
  </>
);
export default Index;
